export const ARMY_KEY = "myArmies";
export const DECK_KEY = "myDecks";
export const GAME_KEY = "myGames";